import script from "./HeaderBeplanet.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBeplanet.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBeplanet.vue?vue&type=style&index=0&id=518e8cf6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-518e8cf6"]])

export default __exports__